import { useState, useEffect, useCallback } from 'react';
import './PromoSlideshow.css';

const SLIDES = [
  { src: '/slab-edit-1.webp', alt: 'The Slab Edit – Travertine White' },
  { src: '/slab-edit-2.webp', alt: 'The Slab Edit – Patagonia Bianco' },
  { src: '/slab-edit-3.webp', alt: 'The Slab Edit – Luxor Blue' },
];

const PROMO_URL = 'https://www.elegantfittings.co.ke/promotions';
const INTERVAL = 4000;

const PromoSlideshow = () => {
  const [idx, setIdx]         = useState(0);
  const [fading, setFading]   = useState(false);

  const goTo = useCallback((next) => {
    setFading(true);
    setTimeout(() => {
      setIdx(next);
      setFading(false);
    }, 300);
  }, []);

  useEffect(() => {
    const t = setInterval(() => {
      goTo((prev) => (prev + 1) % SLIDES.length);
    }, INTERVAL);
    return () => clearInterval(t);
  }, [goTo]);

  return (
    <div className="promo-panel">
      <div className="promo-slides">
        <a
          href={PROMO_URL}
          target="_blank"
          rel="noopener noreferrer"
          className={`promo-slide-link${fading ? ' promo-fade-out' : ' promo-fade-in'}`}
          aria-label="View The Slab Edit promotion"
        >
          <img
            key={idx}
            src={SLIDES[idx].src}
            alt={SLIDES[idx].alt}
            className="promo-slide-img"
            draggable={false}
          />
        </a>

        {/* Dot nav */}
        <div className="promo-dots">
          {SLIDES.map((_, i) => (
            <button
              key={i}
              className={`promo-dot${i === idx ? ' active' : ''}`}
              onClick={() => goTo(i)}
              aria-label={`Slide ${i + 1}`}
            />
          ))}
        </div>
      </div>

      <a
        href={PROMO_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="promo-cta"
      >
        Shop The Slab Edit &rarr;
      </a>
    </div>
  );
};

export default PromoSlideshow;
